import {NgModule, ModuleWithProviders} from '@angular/core';
import {HttpClient, HttpClientModule, HTTP_INTERCEPTORS} from '@angular/common/http';
import {RouterModule} from "@angular/router";
import {StoreModule} from "@ngrx/store";
import {CoreModule, LogService} from "@cosbeni/core";
import {AuthReducer} from "./reducers";
import {IConfigOptions, IPartialConfigOptions} from './services/config.interfaces';
import {CONFIG_OPTIONS, ConfigService} from './services/config.service';
import {StorageService} from './services/storage.service';
import {BrowserStorageService} from './services/browser.storage.service';
import {SharedService} from './services/shared.service';
import {JwtInterceptor} from './services/interceptor.service';
import {OauthService} from './services/oauth.service';
import {PopupService} from './services/popup.service';
import {LocalService} from './services/local.service';
import {AuthService} from './services/auth.service';

@NgModule({
    imports: [
        HttpClientModule,
        RouterModule,
        CoreModule.forRoot([
            {provide: LogService, useClass: LogService}
        ]),
        StoreModule.forFeature('authFeature', {auth: AuthReducer})
    ]
})
export class AuthModule {

    static forRoot(configOptions?: IPartialConfigOptions, defaultJwtInterceptor = true): ModuleWithProviders<AuthModule> {
        return {
            ngModule: AuthModule,
            providers: [
                ...(configOptions ? [{provide: CONFIG_OPTIONS, useValue: configOptions}] : []),
                {provide: ConfigService, useClass: ConfigService, deps: [CONFIG_OPTIONS]},
                {provide: StorageService, useClass: BrowserStorageService, deps: [ConfigService]},
                {provide: SharedService, useClass: SharedService, deps: [StorageService, ConfigService]},
                {provide: LocalService, useClass: LocalService, deps: [HttpClient, SharedService, ConfigService]},
                {provide: PopupService, useClass: PopupService, deps: [ConfigService]},
                {provide: OauthService, useClass: OauthService, deps: [HttpClient, SharedService, ConfigService, PopupService]},
                {provide: AuthService, useClass: AuthService, deps: [SharedService, LocalService, OauthService]},
                ...(defaultJwtInterceptor
                    ? [{provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true, deps: [SharedService, ConfigService]}]
                    : [])
            ]
        };
    }
}
